import { render } from "./DataViewContent.vue?vue&type=template&id=8680bd9a"
import script from "./DataViewContent.vue?vue&type=script&lang=js"
export * from "./DataViewContent.vue?vue&type=script&lang=js"

import "./DataViewContent.vue?vue&type=style&index=0&id=8680bd9a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__